import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { ReactComponent as CloseIcon } from '../../assets/icons/x.svg';
import './Modal.css';

export const ModalCloseButton = ({
  onClick,
  label = 'Close modal',
  iconClassName = 'icon base',
}) => (
  <button
    type="button"
    className="modal__close btn btn-icon"
    onClick={onClick}
    aria-label={label}
  >
    <CloseIcon className={iconClassName} />
  </button>
);

const Modal = ({ isOpen, onClose, children, className = '' }) => {
  useEffect(() => {
    if (!isOpen || typeof document === 'undefined') return undefined;

    const root = document.documentElement;
    const body = document.body;
    const currentCount = Number(body.dataset.modalOpenCount || 0);
    const nextCount = currentCount + 1;
    const scrollY = window.scrollY || window.pageYOffset || root.scrollTop || body.scrollTop || 0;

    body.dataset.modalOpenCount = String(nextCount);
    if (currentCount === 0) {
      body.dataset.modalScrollY = String(scrollY);
    }
    body.classList.add('modal-open');

    return () => {
      const activeCount = Number(body.dataset.modalOpenCount || 1);
      const remaining = Math.max(0, activeCount - 1);

      if (remaining === 0) {
        const restoreY = Number(body.dataset.modalScrollY || 0);
        delete body.dataset.modalOpenCount;
        delete body.dataset.modalScrollY;
        body.classList.remove('modal-open');
        window.requestAnimationFrame(() => {
          window.scrollTo(0, restoreY);
        });
      } else {
        body.dataset.modalOpenCount = String(remaining);
      }
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const overlay = (
    <div
      className={`modal-overlay ${className}`.trim()}
      onClick={(event) => {
        if (event.target === event.currentTarget && typeof onClose === 'function') {
          onClose();
        }
      }}
    >
      {children}
    </div>
  );

  if (typeof document === 'undefined') return overlay;

  return createPortal(overlay, document.body);
}


export default Modal;
